import ActionCardStore from "./ActionCardStore";
import BootStore from "./BootStore";
import AvailabilityStore from "./AvailabilityStore";
import BotStore from "./BotStore";
import CallStore from "./CallStore";
import ChatStore from "./ChatStore";
import ConversionStore from "./ConversionStore";
import CookieStore from "./CookieStore";
import DynamicButtonStore from "./DynamicButtonStore";
import EcommerceStore from "./EcommerceStore";
import EngagementStore from "./EngagementStore";
import FrameStore from "./FrameStore";
import GroupStore from "./GroupStore";
import InviteStore from "./InviteStore";
import LocalStorageStore from "./LocalStorageStore";
import OAuthStore from "./OAuthStore";
import PageHitStore from "./PageHitStore";
import PostMessageStore from "./PostMessageStore";
import SettingStore from "./SettingStore";
import VisitorActionStore from "./VisitorActionStore";
import VisitorStore from "./VisitorStore";
import ParentWindowEventStore from "./ParentWindowEventStore";
import UtmStore from "./UtmStore";
import LanguageStore from "./LanguageStore";
import CobrowseStore from "./CobrowseStore";
import CallButtonStore from "./CallButtonStore";

export default class StoreContainer {
  static ActionCardStore: ActionCardStore;
  static AvailabilityStore: AvailabilityStore;
  static BootStore: BootStore;
  static BotStore: BotStore;
  static CallStore: CallStore;
  static ChatStore: ChatStore;
  static ConversionStore: ConversionStore;
  static CookieStore: CookieStore;
  static DynamicButtonStore: DynamicButtonStore;
  static CallButtonStore: CallButtonStore;
  static EcommerceStore: EcommerceStore;
  static EngagementStore: EngagementStore;
  static FrameStore: FrameStore;
  static GroupStore: GroupStore;
  static InviteStore: InviteStore;
  static LocalStorageStore: LocalStorageStore;
  static OAuthStore: OAuthStore;
  static PageHitStore: PageHitStore;
  static PostMessageStore: PostMessageStore;
  static SettingStore: SettingStore;
  static VisitorActionStore: VisitorActionStore;
  static UtmStore: UtmStore;
  static VisitorStore: VisitorStore;
  static ParentWindowEventStore: ParentWindowEventStore;
  static LanguageStore: LanguageStore;
  static CobrowseStore: CobrowseStore;

  static initialize() {
    this.CookieStore = new CookieStore();
    this.ParentWindowEventStore = new ParentWindowEventStore();
    this.LanguageStore = new LanguageStore();
    this.ActionCardStore = new ActionCardStore();
    this.AvailabilityStore = new AvailabilityStore();
    this.BootStore = new BootStore();
    this.BotStore = new BotStore();
    this.CallStore = new CallStore(this.CookieStore);
    this.ChatStore = new ChatStore();
    this.ConversionStore = new ConversionStore();
    this.DynamicButtonStore = new DynamicButtonStore();
    this.CallButtonStore = new CallButtonStore();
    this.EcommerceStore = new EcommerceStore();
    this.EngagementStore = new EngagementStore(this.CookieStore);
    this.FrameStore = new FrameStore(this.CookieStore);
    this.GroupStore = new GroupStore();
    this.InviteStore = new InviteStore(this.ParentWindowEventStore);
    this.LocalStorageStore = new LocalStorageStore();
    this.OAuthStore = new OAuthStore(this.CookieStore);
    this.PageHitStore = new PageHitStore();
    this.PostMessageStore = new PostMessageStore();
    this.SettingStore = new SettingStore();
    this.VisitorActionStore = new VisitorActionStore();
    this.UtmStore = new UtmStore();
    this.CobrowseStore = new CobrowseStore(
      this.ChatStore,
      this.EngagementStore
    );
    this.VisitorStore = new VisitorStore(
      this.CookieStore,
      this.ParentWindowEventStore
    );
  }
}

StoreContainer.initialize();
